export default "__VITE_ASSET__BGQD6VLw__"